/**
 * http interceptor: kiszedi a headerből a szüséges infókat és Broadcasten elküldi a kontrollereknek
 * @author: Bálint Ádám
 */
export default function (app) {
	app.factory('httpInterceptor', ['$q', '$rootScope', function ($q, $rootScope) {
		return {
			request: function (config) {
				$rootScope.$broadcast('ajax:started');
				return config;
			},
			response: function (response) {
				$rootScope.$broadcast('ajax:finished');
				return response;
			},
			responseError: function (rejection) {
				$rootScope.$broadcast('ajax:finished');
				return $q.reject(rejection);
			}
		};
	}]).config(['$httpProvider', function ($httpProvider) {
		$httpProvider.interceptors.push('httpInterceptor');
	}]);
}
